/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes, {
    array, func, object, string,
} from 'prop-types';

// Material UI
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {
    FormControl, Grid, MenuItem, Select, withStyles,
} from '@material-ui/core';

const styles = (theme) => ({
    formControlRoot: {
        margin: '19px 0px 18px',
        '& >div': {
            fontSize: '1em',
        },
        '& fieldset': {
            border: 0,
        },
        '& svg': {
            right: 0,
        },
        [theme.breakpoints.down(408)]: {
            margin: '10px 0',
        },
    },
    selectMenu: {
        fontFamily: 'Helvetica, Arial, Verdana, sans-serif',
        padding: 0,
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: 'transparent',
        },
    },
    menuItem: {
        fontFamily: 'Helvetica, Arial, Verdana, sans-serif',
        fontSize: '1em',
    },
    selectOutline: {
        padding: '5px 30px 5px 5px',
        fontWeight: 'bold',
        [theme.breakpoints.down(670)]: {
            fontSize: '0.88em',
        },
        [theme.breakpoints.down(408)]: {
            fontSize: '0.75em',
        },
    },
});

const ShipHolidaysList = ({
    classes,
    shipHolidays,
    holidaySelected,
    onHolidaySelected,
}) => {
    let holidayValue = holidaySelected;
    if (holidayValue === 'Choose Holiday') {
        holidayValue = '';
    }

    const getHolidayList = () => {
        const holidayList = shipHolidays.map((holiday) => (
            <MenuItem className={classes.menuItem} key={holiday.holidayCode} value={holiday.holidayCode}>
                {holiday.holidayDesc}
            </MenuItem>
        ));
        holidayList.unshift(
            <MenuItem key="holidayListEmpty" className={classes.menuItem} value="" disabled>
                Choose Holiday
            </MenuItem>,
        );
        return holidayList;
    };

    if (shipHolidays?.length > 0) {
        return (
            <Grid id="holiday-list" container justifyContent="flex-end">
                <FormControl
                    className={classes.formControlRoot}
                >
                    <Select
                        autoWidth
                        classes={{
                            selectMenu: classes.selectMenu,
                            outlined: classes.selectOutline,
                        }}
                        data-testid="shipHoliday"
                        displayEmpty
                        id="shipHoliday"
                        IconComponent={KeyboardArrowDownIcon}
                        onChange={(event) => onHolidaySelected(event.target.value)}
                        value={holidayValue}
                        variant="outlined"
                    >
                        {getHolidayList()}
                    </Select>
                </FormControl>
            </Grid>
        );
    }

    return null;
};

ShipHolidaysList.propTypes = {
    classes: object.isRequired,
    shipHolidays: array.isRequired,
    holidaySelected: string.isRequired,
    onHolidaySelected: func.isRequired,
};

export default withStyles(styles)(ShipHolidaysList);
